import { computed, signal } from '@preact/signals-react';

import { type ProductModel } from '@/entities/product/model';
import { RestaurantApi } from '@/entities/restaurant/api';

const products = signal<ProductModel[]>([]);
const loading = signal(false);

export const productsStore = {
  products,
  loading,

  async loadProducts(restaurantId: number) {
    loading.value = true;
    try {
      const items = await RestaurantApi.getRestaurantMenu(restaurantId);
      products.value = items;
    } finally {
      loading.value = false;
    }
  },

  grouped: computed(() => {
    const map = new Map<string, ProductModel[]>();
    products.value.forEach((product) => {
      if (!product.category?.id) return;
      const catId = String(product.category.id);
      (map.get(catId) ?? map.set(catId, []).get(catId)!).push(product);
    });

    return Array.from(map.entries()).map(([catId, items]) => ({
      id: catId,
      label: items[0]?.category?.name || 'Без категории',
      products: items,
    }));
  }),

  getProductVariants(product: ProductModel): ProductModel[] {
    let mainProduct: ProductModel | undefined = product;

    if (!product.menuItemsVariants?.length) {
      mainProduct = products.value.find((p) =>
        p.menuItemsVariants?.includes(product.menuItemId)
      );
    }

    if (!mainProduct) return [product];

    return [
      mainProduct,
      ...((
        mainProduct.menuItemsVariants?.map((menuItemId) =>
          products.value.find((p) => p.menuItemId === menuItemId)
        ) ?? []
      ).filter(Boolean) as ProductModel[]),
    ].sort();
  },

  findProductById: (productId: number) =>
    computed(() => products.value.find((p) => p.id === productId)),
};
